import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Include Both Helper File with needed methods
import {
	getActivityList as getActivityListApi,
	getActivity as getActivityApi,
	addNewActivity as addNewActivityApi,
	addActivitiesProductiveCycle as addActivitiesProductiveCycleApi,
	updateActivity as updateActivityApi,
	deleteActivity as deleteActivityApi,
	getActualActivitiesList as getActualActivitiesListApi,
	getActivityGroupList as getActivityGroupListApi,
	getActivityGroup as getActivityGroupApi,
	getActivityGroupByCode as getActivityGroupByCodeApi,
	addNewActivityGroup as addNewActivityGroupApi,
	updateActivityGroup as updateActivityGroupApi,
	deleteActivityGroup as deleteActivityGroupApi,
	getActivityPeriodicityList as getActivityPeriodicityListApi,
	getActivityPeriodicity as getActivityPeriodicityApi,
	getActivityPeriodicityByCode as getActivityPeriodicityByCodeApi,
	addNewActivityPeriodicity as addNewActivityPeriodicityApi,
	updateActivityPeriodicity as updateActivityPeriodicityApi,
	deleteActivityPeriodicity as deleteActivityPeriodicityApi,
	getActivitiesQuery as getActivitiesQueryApi,
	getActivityPriorityList as getActivityPriorityListApi,
	getActivityPriority as getActivityPriorityApi,
	getActivityPriorityByCode as getActivityPriorityByCodeApi,
	addNewActivityPriority as addNewActivityPriorityApi,
	updateActivityPriority as updateActivityPriorityApi,
	deleteActivityPriority as deleteActivityPriorityApi,
	getActivityStatusList as getActivityStatusListApi,
	getActivityStatus as getActivityStatusApi,
	getActivityStatusByCode as getActivityStatusByCodeApi,
	addNewActivityStatus as addNewActivityStatusApi,
	updateActivityStatus as updateActivityStatusApi,
	deleteActivityStatus as deleteActivityStatusApi,
	getActivityTemplateList as getActivityTemplateListApi,
	getActivityTemplate as getActivityTemplateApi,
	getActivityTemplateCode as getActivityTemplateCodeApi,
	addNewActivityTemplate as addNewActivityTemplateApi,
	updateActivityTemplate as updateActivityTemplateApi,
	deleteActivityTemplate as deleteActivityTemplateApi,
	getActivityTemplateItemList as getActivityTemplateItemListApi,
	getActivityTemplateItem as getActivityTemplateItemApi,
	addNewActivityTemplateItem as addNewActivityTemplateItemApi,
	updateActivityTemplateItem as updateActivityTemplateItemApi,
	deleteActivityTemplateItem as deleteActivityTemplateItemApi,
	getActivityTypeList as getActivityTypeListApi,
	getActivityType as getActivityTypeApi,
	getActivityTypeByCode as getActivityTypeByCodeApi,
	addNewActivityType as addNewActivityTypeApi,
	updateActivityType as updateActivityTypeApi,
	deleteActivityType as deleteActivityTypeApi,
	updateStatusActivity as updateStatusActivityApi,
} from '../../helpers/activity/backend_helper';

// Activity
export const getActivityList = createAsyncThunk(
	'activities/getActivityList',
	async params => {
		try {
			const response = await getActivityListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivitiesQuery = createAsyncThunk(
	'activities/getActivitiesQuery',
	async query => {
		try {
			const response = await getActivitiesQueryApi(query);
			return response;
		} catch (error) {
			// toast.error('Error al obtener actividades.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const getActivity = createAsyncThunk(
	'activities/getActivity',
	async activity_id => {
		try {
			const response = await getActivityApi(activity_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityByCode = createAsyncThunk(
	'activities/getActivityByCode',
	async code => {
		try {
			const response = await getActivityByCodeApi(code);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewActivity = createAsyncThunk(
	'activities/addNewActivity',
	async activity => {
		try {
			const response = await addNewActivityApi(activity);
			return response;
		} catch (error) {
			toast.error('Error al agregar actividad.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const addActivitiesProductiveCycle = createAsyncThunk(
	'activities/addActivitiesProductiveCycle',
	async activity => {
		try {
			toast.info(
				'Estamos generando las actividades de nuevo ciclo productivo.',
				{ autoClose: 6000 }
			);
			const response = await addActivitiesProductiveCycleApi(activity);
			toast.success(
				'Actividades generadas de ciclo productivo exitosamente.',
				{ autoClose: 3000 }
			);
			return response;
		} catch (error) {
			toast.error('Error al agregar actividades a ciclo productivo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateActivity = createAsyncThunk(
	'activities/updateActivity',
	async activity => {
		try {
			const response = await updateActivityApi(activity);
			toast.success('Actividad actualizada exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar actividad.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteActivity = createAsyncThunk(
	'activities/deleteActivity',
	async activity => {
		try {
			const response = await deleteActivityApi(activity);
			toast.success('Actividad eliminada exitosamente.', {
				autoClose: 3000,
			});
			return { activity, ...response };
		} catch (error) {
			toast.error('Error al eliminar actividad.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const getActualActivitiesList = createAsyncThunk(
	'activities/getActualActivitiesList',
	async () => {
		try {
			const response = await getActualActivitiesListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

// Activity Group
export const getActivityGroupList = createAsyncThunk('activityGroups/getActivityGroupList',	async ({ categories }) => {
			try {
					const params = {
							categories: categories ? categories.join(',') : ''
					};
					const response = await getActivityGroupListApi(params);
					return response;
			} catch (error) {
					return Promise.reject(error.message || 'Error fetching activity groups');
			}
	}
);



export const getActivityGroup = createAsyncThunk(
	'activityGroups/getActivityGroup',
	async activityGroup_id => {
		try {
			const response = await getActivityGroupApi(activityGroup_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityGroupByCode = createAsyncThunk(
	'activityGroups/getActivityGroupByCode',
	async code => {
		try {
			const response = await getActivityGroupByCodeApi(code);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewActivityGroup = createAsyncThunk(
	'activityGroups/addNewActivityGroup',
	async activityGroup => {
		try {
			const response = await addNewActivityGroupApi(activityGroup);
			toast.success('Activity Group agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar activity group.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateActivityGroup = createAsyncThunk(
	'activityGroups/updateActivityGroup',
	async activityGroup => {
		try {
			const response = await updateActivityGroupApi(activityGroup);
			toast.success('Activity Group actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar activity group.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteActivityGroup = createAsyncThunk(
	'activityGroups/deleteActivityGroup',
	async activityGroup => {
		try {
			const response = await deleteActivityGroupApi(activityGroup);
			toast.success('Activity Group eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { activityGroup, ...response };
		} catch (error) {
			toast.error('Error al eliminar activity group.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

// Activity Periodicity
export const getActivityPeriodicityList = createAsyncThunk(
	'activityPeriodicities/getActivityPeriodicityList',
	async () => {
		try {
			const response = await getActivityPeriodicityListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityPeriodicity = createAsyncThunk(
	'activityPeriodicities/getActivityPeriodicity',
	async activityPeriodicity_id => {
		try {
			const response = await getActivityPeriodicityApi(
				activityPeriodicity_id
			);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityPeriodicityByCode = createAsyncThunk(
	'activityPeriodicities/getActivityPeriodicityByCode',
	async code => {
		try {
			const response = await getActivityPeriodicityByCodeApi(
				code
			);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewActivityPeriodicity = createAsyncThunk(
	'activityPeriodicities/addNewActivityPeriodicity',
	async activityPeriodicity => {
		try {
			const response = await addNewActivityPeriodicityApi(
				activityPeriodicity
			);
			toast.success('Activity Periodicity agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar activity periodicity.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateActivityPeriodicity = createAsyncThunk(
	'activityPeriodicities/updateActivityPeriodicity',
	async activityPeriodicity => {
		try {
			const response = await updateActivityPeriodicityApi(
				activityPeriodicity
			);
			toast.success('Activity Periodicity actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar activity periodicity.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteActivityPeriodicity = createAsyncThunk(
	'activityPeriodicities/deleteActivityPeriodicity',
	async activityPeriodicity => {
		try {
			const response = await deleteActivityPeriodicityApi(
				activityPeriodicity
			);
			toast.success('Activity Periodicity eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { activityPeriodicity, ...response };
		} catch (error) {
			toast.error('Error al eliminar activity periodicity.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

// Activity Priority
export const getActivityPriorityList = createAsyncThunk(
	'activityPriorities/getActivityPriorityList',
	async () => {
		try {
			const response = await getActivityPriorityListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityPriority = createAsyncThunk(
	'activityPriorities/getActivityPriority',
	async activityPriority_id => {
		try {
			const response = await getActivityPriorityApi(activityPriority_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityPriorityByCode = createAsyncThunk(
	'activityPriorities/getActivityPriorityByCode',
	async code => {
		try {
			const response = await getActivityPriorityByCodeApi(code);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewActivityPriority = createAsyncThunk(
	'activityPriorities/addNewActivityPriority',
	async activityPriority => {
		try {
			const response = await addNewActivityPriorityApi(activityPriority);
			toast.success('Activity Priority agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar activity priority.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateActivityPriority = createAsyncThunk(
	'activityPriorities/updateActivityPriority',
	async activityPriority => {
		try {
			const response = await updateActivityPriorityApi(activityPriority);
			toast.success('Activity Priority actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar activity priority.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteActivityPriority = createAsyncThunk(
	'activityPriorities/deleteActivityPriority',
	async activityPriority => {
		try {
			const response = await deleteActivityPriorityApi(activityPriority);
			toast.success('Activity Priority eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { activityPriority, ...response };
		} catch (error) {
			toast.error('Error al eliminar activity priority.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

// Activity Status
export const getActivityStatusList = createAsyncThunk(
	'activityStatuses/getActivityStatusList',
	async () => {
		try {
			const response = await getActivityStatusListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityStatus = createAsyncThunk(
	'activityStatuses/getActivityStatus',
	async activityStatus_id => {
		try {
			const response = await getActivityStatusApi(activityStatus_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityStatusByCode = createAsyncThunk(
	'activityStatuses/getActivityStatusByCode',
	async code => {
		try {
			const response = await getActivityStatusByCodeApi(code);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewActivityStatus = createAsyncThunk(
	'activityStatuses/addNewActivityStatus',
	async activityStatus => {
		try {
			const response = await addNewActivityStatusApi(activityStatus);
			toast.success('Activity Status agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar activity status.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateActivityStatus = createAsyncThunk(
	'activityStatuses/updateActivityStatus',
	async activityStatus => {
		try {
			const response = await updateActivityStatusApi(activityStatus);
			toast.success('Activity Status actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar activity status.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteActivityStatus = createAsyncThunk(
	'activityStatuses/deleteActivityStatus',
	async activityStatus => {
		try {
			const response = await deleteActivityStatusApi(activityStatus);
			toast.success('Activity Status eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { activityStatus, ...response };
		} catch (error) {
			toast.error('Error al eliminar activity status.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

// Activity Template
export const getActivityTemplateList = createAsyncThunk(
	'activityTemplates/getActivityTemplateList',
	async () => {
		try {
			const response = await getActivityTemplateListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityTemplate = createAsyncThunk(
	'activityTemplates/getActivityTemplate',
	async activityTemplate_id => {
		try {
			const response = await getActivityTemplateApi(activityTemplate_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityTemplateCode = createAsyncThunk(
	'activityTemplates/getActivityTemplateCode',
	async code => {
		try {
			const response = await getActivityTemplateCodeApi(code);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewActivityTemplate = createAsyncThunk(
	'activityTemplates/addNewActivityTemplate',
	async activityTemplate => {
		try {
			const response = await addNewActivityTemplateApi(activityTemplate);
			toast.success('Activity Template agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar activity template.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateActivityTemplate = createAsyncThunk(
	'activityTemplates/updateActivityTemplate',
	async activityTemplate => {
		try {
			const response = await updateActivityTemplateApi(activityTemplate);
			toast.success('Activity Template actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar activity template.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteActivityTemplate = createAsyncThunk(
	'activityTemplates/deleteActivityTemplate',
	async activityTemplate => {
		try {
			const response = await deleteActivityTemplateApi(activityTemplate);
			toast.success('Activity Template eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { activityTemplate, ...response };
		} catch (error) {
			toast.error('Error al eliminar activity template.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

// Activity Template Item
export const getActivityTemplateItemList = createAsyncThunk(
	'activityTemplateItems/getActivityTemplateItemList',
	async params => {
		try {
			const response = await getActivityTemplateItemListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityTemplateItem = createAsyncThunk(
	'activityTemplateItems/getActivityTemplateItem',
	async activityTemplateItem_id => {
		try {
			const response = await getActivityTemplateItemApi(
				activityTemplateItem_id
			);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewActivityTemplateItem = createAsyncThunk(
	'activityTemplateItems/addNewActivityTemplateItem',
	async activityTemplateItem => {
		try {
			const response = await addNewActivityTemplateItemApi(
				activityTemplateItem
			);
			toast.success('Plantilla de la Actividad agregada exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar Plantilla de la Actividad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateActivityTemplateItem = createAsyncThunk(
	'activityTemplateItems/updateActivityTemplateItem',
	async activityTemplateItem => {
		try {
			const response = await updateActivityTemplateItemApi(
				activityTemplateItem
			);
			toast.success('Plantilla de la Actividad actualizada exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar Plantilla de la Actividad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteActivityTemplateItem = createAsyncThunk(
	'activityTemplateItems/deleteActivityTemplateItem',
	async activityTemplateItem => {
		try {
			const response = await deleteActivityTemplateItemApi(
				activityTemplateItem
			);
			toast.success('Plantilla de la Actividad eliminada exitosamente.', {
				autoClose: 3000,
			});
			return { activityTemplateItem, ...response };
		} catch (error) {
			toast.error('Error al eliminar activity template item.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

// Activity Type
export const getActivityTypeList = createAsyncThunk(
	'activityTypes/getActivityTypeList',
	async () => {
		try {
			const response = await getActivityTypeListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityType = createAsyncThunk(
	'activityTypes/getActivityType',
	async activityType_id => {
		try {
			const response = await getActivityTypeApi(activityType_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getActivityTypeByCode = createAsyncThunk(
	'activityTypes/getActivityTypeByCode',
	async code => {
		try {
			const response = await getActivityTypeByCodeApi(code);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewActivityType = createAsyncThunk(
	'activityTypes/addNewActivityType',
	async activityType => {
		try {
			const response = await addNewActivityTypeApi(activityType);
			toast.success('Activity Type agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar activity type.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateActivityType = createAsyncThunk(
	'activityTypes/updateActivityType',
	async activityType => {
		try {
			const response = await updateActivityTypeApi(activityType);
			toast.success('Activity Type actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar activity type.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteActivityType = createAsyncThunk(
	'activityTypes/deleteActivityType',
	async activityType => {
		try {
			const response = await deleteActivityTypeApi(activityType);
			toast.success('Activity Type eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { activityType, ...response };
		} catch (error) {
			toast.error('Error al eliminar activity type.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateStatusActivity = createAsyncThunk(
	'activityTypes/updateStatusActivity',
	async activity => {
		// toast.info('Actualizando estado de actividad.', { autoClose: 3000 });
		try {
			const response = await updateStatusActivityApi(activity);
			toast.success('Estado de actividad actualizado.', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar estado de actividad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
